import { userConstants } from '../constants/user.constants';

export function currentUser(state = null, action) {
    switch (action.type) {
        case userConstants.SET_CURRENT_USER:
            return action.user;
        case userConstants.LOGOUT:
            return null;
        default:
            return state;
    }
}
